module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki15_sp-d6760861982a5450b95b5600c5741514.jpg";